// extracted by mini-css-extract-plugin
export default {"iconWrapper":"style_iconWrapper__ZdNyz","checkIconWrapper":"style_checkIconWrapper__NEplR","heading":"style_heading__I6nj4","content":"style_content__z1KCw"};